import React from 'react';
import PropTypes from 'prop-types';

import Heading from 'components/Heading';
import Icon from 'components/Icon';

import theme from 'styles/themes/wikifactory';

import { TagStyled } from './Tag.styled';

export default function Tag({ tag, href }) {
  if (href) {
    return (
      <a href={href}>
        <TagStyled>
          <Heading level='3' size='large'>
            {tag}
          </Heading>
          <Icon name='arrow_right' colorPath={theme.color.wfBlack} />
        </TagStyled>
      </a>
    );
  }
  return (
    <TagStyled>
      <Heading level='3' size='large'>
        {tag}
      </Heading>
      <Icon name='arrow_right' colorPath={theme.color.wfBlack} />
    </TagStyled>
  );
}

Tag.defaultProps = {
  tag: '#Default Tag',
  href: '',
};

Tag.propTypes = {
  /**
   * This prop is the main title of the tag
   */
  tag: PropTypes.string,
  /**
   * This prop is a hyperlink to a web page
   */
  href: PropTypes.string,
};
